<template>
  <el-card class="box-card clickable"
           :style="styleMe"
           style="color: #ffffff;font-weight: bold"
           :body-style="cardBodyStyle" >
    <div class="d-flex justify-content-center dash-content">
      <span class="align-self-center title" >{{title}}</span>
    </div>
  </el-card>
</template>

<script>
  export default {
    name: "DashItemMenu",
    props: {
      selected: {
        required: true
      },
      title: {
        required: true
      }
    },
    data() {
      return {
        cardBodyStyle: {
          padding: '0px'
        },
        types: {
          active: {
            backgroundColor: '#9933CC',
            borderColor: '#9933CC'
          },
          normal: {
            color: "#212121",
            backgroundColor: '#fff',
            borderColor: '#fff'
          }
        }
      }
    },
    computed: {
      styleMe: function () {
        return this.selected ? this.types.active : this.types.normal
      }
    }
  }
</script>

<style scoped>
  .title{
    font-size: .85em;
  }
  .dash-content {
    padding-top: .85em;
    padding-bottom: .85em;
  }

  .el-card__body {
    padding: 0px;
  }

  .box-card .value {
    font-size: 1.5em;
    padding: .6em;
  }
</style>



// WEBPACK FOOTER //
// src/features/Dashboard/DashItemMenu.vue